import { render, staticRenderFns } from "./SidebarEnterpriseCustomer.vue?vue&type=template&id=b23c4e90&scoped=true"
import script from "./SidebarEnterpriseCustomer.vue?vue&type=script&lang=js"
export * from "./SidebarEnterpriseCustomer.vue?vue&type=script&lang=js"
import style0 from "./SidebarEnterpriseCustomer.vue?vue&type=style&index=0&id=b23c4e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23c4e90",
  null
  
)

export default component.exports